var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[_c('tab-group'),_c('div',{staticClass:"section-wrapper"},[_vm._v("车辆和部门")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }